/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_Required_DescriptionInputs */



/**
* | output |
* | --- |
* | "The owner of this page requires visitors to sign in." |
*
* @param {Canvas_Sign_In_Required_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_required_description = /** @type {((inputs?: Canvas_Sign_In_Required_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_Required_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Inhaberin oder der Inhaber dieser Seite verlangt eine Anmeldung.")
	return /** @type {LocalizedString} */ ("The owner of this page requires visitors to sign in.")
});